import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { PADDING } from '@/constants/residents/homeConstants';

interface CloseButtonProps {
  onPress: () => void;
  top?: number;
  right?: number;
  accessibilityLabel?: string;
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  onPress,
  top = PADDING.padding4,
  right = PADDING.padding4,
  accessibilityLabel = 'Close',
}) => {
  return (
    <TouchableOpacity
      style={[
        styles.closeButton,
        {
          top,
          right,
        }
      ]}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <Icon 
        name="close" 
        size={14} 
        color="#FFFFFF" 
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  // iOS CloseButton - positioned at top right of modal
  closeButton: {
    position: 'absolute',
    width: 24, // iOS: .CloseButton.diameter = 24.0
    height: 24, // iOS: .CloseButton.diameter = 24.0  
    borderRadius: 12, // iOS: .CloseButton.radius = 12.0
    backgroundColor: 'rgba(0, 0, 0, 0.55)', // iOS: .Button.closeBackground = blackOverlay55
    justifyContent: 'center',
    alignItems: 'center',
    // iOS shadow for close button
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
});
